// extracted by mini-css-extract-plugin
module.exports = {"home":"index_home__ZdSNF"};